import { ENDPOINTS, get } from '~/api'
import { keysToCamel } from '~/helpers/helpers'
import { Dispatch } from '~/store/types'
import { BankAccount, CURRENCY, STABLECOIN } from '~/types'
import { BANK_ACCOUNT_ACTIONS } from './const'
import { ActionTypes, Bank } from './types'
import { UserInfo } from '~/store/userInfo/types'
import { ACCEPTED_CURRENCY } from '~/store/landing/types'

export const setBankList = (bankList: Bank[], stablecoin: STABLECOIN) => (
  dispatch: Dispatch<ActionTypes>
) => {
  dispatch({
    type: BANK_ACCOUNT_ACTIONS.SET_BANK_LIST,
    stablecoin,
    bankList,
  })
}

export const fetchBankList = () => async (
  dispatch: Dispatch<ActionTypes>,
  onSuccess?: () => void
) => {
  const bankList = await get(ENDPOINTS.API_V3_BANKS)
  if (bankList) {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-argument
    dispatch(setBankList(keysToCamel(bankList), CURRENCY.XSGD))
  }

  if (onSuccess) {
    onSuccess()
  }
}

const setBankAccountList = (bankAccountList: BankAccount[], currency: ACCEPTED_CURRENCY) => (
  dispatch: Dispatch<ActionTypes>
) => {
  dispatch({
    type: BANK_ACCOUNT_ACTIONS.SET_BANK_ACCOUNT_LIST,
    stablecoin: currency,
    bankAccountList,
  })
}

export const fetchBankAccountList = () => async (dispatch: Dispatch<ActionTypes>) => {
  const resp = await get(ENDPOINTS.API_V3_USER)
  const userInfo: UserInfo = keysToCamel(resp)

  const isFiatWalletOnly = userInfo.fiatWalletOnly
  const isEnabledBank = (item: BankAccount) => item.disabled === 'false'

  // TODO(benedictkhoo): have an API for bank accounts, the action is now calling /api/v3/user to get bank accounts
  if (userInfo.bankAccounts) {
    const bankAccounts = userInfo.bankAccounts.filter(isEnabledBank)
    dispatch(setBankAccountList(bankAccounts, isFiatWalletOnly ? CURRENCY.SGD : CURRENCY.XSGD))
  }

  if (userInfo.usdcExtension?.bankAccounts) {
    const bankAccounts = userInfo.usdcExtension.bankAccounts.filter(isEnabledBank)
    dispatch(setBankAccountList(bankAccounts, isFiatWalletOnly ? CURRENCY.USD : CURRENCY.USDC))
  }

  if (userInfo.xusdExtension?.bankAccounts) {
    const bankAccounts = userInfo.xusdExtension.bankAccounts.filter(isEnabledBank)
    dispatch(setBankAccountList(bankAccounts, CURRENCY.XUSD))
  }
}
